<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :multiple="multiple" :clearable="true" placeholder="Select" v-loading="isLoading">
    <el-option v-for="department in departmentList" :value="department.id" :label="department.name" :key="department.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    },
    multiple: {
      default: false
    }
  },
  data () {
    return {
      departmentList: Array,
      isLoading: true
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  methods: {
    fetchDepartmentList () {
      var call = '/getDepartmentList'
      this.$axios.get(call).then(response => {
        this.departmentList = response.data
        this.isLoading = false
      }).catch(reject => {
        this.isLoading = false
        if (this.$route.name === 'PEA') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Departments', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'Custom Grouping Reports') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Departments', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'advancedSearch') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Departments', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'createPEA') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Departments', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'ClonedPEA') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Departments', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'Print PEA') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Departments', reject.body, 'error', 30000, '')
        }
      })
    }
  },
  created () {
    this.fetchDepartmentList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
